module.exports = __webpack_public_path__ + "static/media/2.cd726380.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/2.svg
// module id = 392
// module chunks = 14